module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-advanced--black-8c048b54c8480046deebcd53d75c70cb.svg";